import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { Backdrop, Button, InputLabel, Paper, styled, TextField } from "@mui/material";

import { ICollection } from "services/types";
import colors from "theme/themeConstants";
import { ToggleButton } from "components/buttons/ToggleButton";
import cross from "components/icons/cross-black.svg";
// TODO: Already replaced in 2A0jCZ0v branch
import trashcanIconBlack from "components/icons/trashcanIconBlack.png";
import { editCollection } from "store/collections/collections-action";

interface IProps {
  isOpen: boolean;
  togglePopup: () => void;
  handleDeleteCollection: () => void;
  collection: ICollection;
}

export const EditCollectionPopup = ({ isOpen, togglePopup, handleDeleteCollection, collection }: IProps) => {

  const { control, handleSubmit, reset } = useForm();

  const dispatch = useDispatch();

  const stopPropagation = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  const handleClose = (event: React.MouseEvent) => {
    stopPropagation(event);
    togglePopup();
  };

  const onSubmit = (data: any) => {
    data.published = !data.published;
    dispatch(editCollection({
      ...data,
      collectionId: collection.folderId
    }));
    togglePopup();
  };

  useEffect(() => {
    reset({
      published: !collection.published,
      folderName: collection.folderName,
      description: collection.description ? collection.description : ""
    });
    // eslint-disable-next-line
  }, [collection])

  return (
    <Backdrop open={isOpen} id="edit-collection-popupOpen"
      sx={{
        zIndex: 33
      }}
      onClick={handleClose}>
      <Paper
        onClick={stopPropagation}
        sx={{
          maxWidth: "460px",
          width: "90%",
          padding: "2rem 30px",
          borderRadius: "24px",
          zIndex: 22,
          "*": {
            fontFamily: "'Poppins', sans-serif!important"
          },
          "@media screen and (max-width: 767px)": {
            padding: "2rem 1rem"
          }
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <PopupSubheader >
            <h3>Edit this collection</h3>
            <Button onClick={togglePopup}><img src={cross} alt="close popup" /></Button>
          </PopupSubheader>

          <InputLabel sx={{ fontSize: "12px", fontWeight: 500, fontFamily: "Poppins" }}>Collection name</InputLabel>
          <Controller
            name="folderName"
            control={control}
            defaultValue=""
            rules={{ required: "Required Field!" }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                sx={{
                  "& div": {
                    borderRadius: "12px",
                    margin: "0.5rem 0",
                    "& input": {
                      padding: "13px 16px",
                      fontSize: "14px"
                    }
                  }
                }}
                fullWidth
                onChange={onChange}
                value={value}
                error={!!error}
              />
            )}
          />
          <InputLabel sx={{ fontSize: "12px", fontWeight: 500, fontFamily: "Poppins" }}>
            Description
          </InputLabel>
          <Controller
            name="description"
            control={control}
            defaultValue=""
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                rows={3}
                multiline
                sx={{
                  "& div": {
                    borderRadius: "12px",
                    margin: "0.5rem 0",
                    "& input": {
                      padding: "13px 16px",
                      fontSize: "14px"
                    }
                  }
                }}
                fullWidth
                onChange={onChange}
                value={value}
                error={!!error}
              />
            )}
          />
          <FlexSwitchContainer>
            <p>Make private</p>
            <Controller
              name="published"
              control={control}
              defaultValue=""
              render={({ field: { onChange, value }, fieldState: { error } }) => (
                <ToggleButton checked={!!value} onChange={onChange}/>
              )}
            />
          </FlexSwitchContainer>

          <Button variant="contained" fullWidth sx={{
            background: colors.purpleGradient,
            margin: "2rem 0 2rem 0",
            minHeight: "3rem",
            borderRadius: "38px",
            fontWeight: 500,
            boxShadow: "none",
            "&:hover": {
              boxShadow: "none"
            }
          }} type="submit">
            Save changes
          </Button>

          <Button variant="contained" fullWidth
            onClick={handleDeleteCollection}
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
              color: "black",
              justifyContent: "center",
              padding: "0",
              "&:hover": {
                backgroundColor: "transparent",
                boxShadow: "none"
              }
            }}>
            <img src={trashcanIconBlack} alt="Delete"
              style={{ width: "15px", marginRight: "5px" }}
            />
            Delete collection
          </Button>
        </form>
      </Paper>
    </Backdrop>
  );
};

const PopupSubheader = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "2rem",
  "& h3": {
    color: "black !important",
    fontSize: "20px",
    fontWeight: "500",
  },
  "& button": {
    padding: "6px 0",
    minWidth: "32px",
  },
  "& img": {
    width: "32px",
    height: "32px",
  },
});

const FlexSwitchContainer = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  margin: "1rem 0 0 0",
});

